<template>
  <v-main>
    <AppBar />
    <v-layout fill-height column>

      <v-container flex-fill fluid>
        <div class="account-title-block">
          <h3 class="tit">
            <span class="tit-point">본인</span> 인증
          </h3>
          <p class="desc">
            본인 인증 방식은 해피민트의<br />
            이메일 또는 휴대폰 정보로 진행됩니다.
          </p>
        </div>

        <v-tabs v-model="activeCertify" @change="onChangeCertify">
          <template v-for="(certify, i) in certifyTypes">
            <v-tab :ripple="false" :key="i">
              {{ certify.title }}
            </v-tab>
          </template>
        </v-tabs>

        <div class="account-identity-content">
          <!-- 소속 이메일 -->
          <div class="account-identity-body">
            <div class="label font-weight-bold">휴대폰 번호</div>
            <v-form ref="submitForm" v-model="valid"
                    class="form-item"
                    @submit.prevent @reset.prevent
            >
              <!-- 이메일 -->
              <div class="form-item-block">
                <div class="input-group">
                  <v-text-field type="text" solo flat filled required
                                autocomplete="off"
                                :value="certifyValue"
                                :placeholder="certifyType.placeholder"
                                readonly
                  />
                </div>
              </div>
              <div v-if="isVisibleAuthCode" class="form-item-block">
                <div class="input-group">
                  <v-text-field solo flat filled required
                                inputmode="numeric"
                                ref="authCode"
                                v-model="authCode"
                                :rules="rule"
                                :readonly="timeOver"
                                :error-messages="errorMessage"
                                placeholder="인증번호 입력"
                                @input="authCodeChk = null"
                  >
                    <template #append>
                      <Timer v-show="authCodeChk !== 'success'" ref="timer" @timeOver="onTimeOver" />
                    </template>
                  </v-text-field>
                  <v-btn :ripple="false" depressed
                         color="primary" class="btn-input"
                         width="115px"
                         :loading="isLoading"
                         @click="requestAuthEmail()"
                  >재발송</v-btn>
                </div>
              </div>
            </v-form>
          </div>
        </div>
      </v-container>
      <v-footer color="white" class="content-footer">
        <div class="flex-grow-1 text-center pt-2" style="color: var(--v-primary-darken5)">
          {{ !timeOver ? sendSuccessMsg : null }}
        </div>
        <div class="footer-btns pt-2">
          <v-btn color="primary" class="btn-basic"
                 x-large depressed
                 :loading="isLoading"
                 :disabled="!valid && isVisibleAuthCode"
                 @click="onSubmit"
          >{{ isVisibleAuthCode ? '인증번호 확인' : '인증 요청' }}</v-btn>
        </div>
      </v-footer>
    </v-layout>
  </v-main>
</template>

<script>
// import store from '@/store'
import Util from '@/utils/utils'
import Timer from '@/components/util/Timer.vue'
import store from "@/store";

const CERTIFY_TYPES = () => {
  return [
    {
      code: 'SMS',
      title: '휴대폰 인증',
      label: '휴대폰 번호',
      placeholder: '휴대폰 번호'
    },
    {
      code: 'EMAIL',
      title: '이메일 인증',
      label: '이메일',
      placeholder: '소속 회사 이메일'
    }
  ]
}

export default {
  components: { Timer },
  data: () => ({
    isLoading: false,
    activeCertify: 0,
    payload: null, // 해피민트 인증
    certifyValue: '', // 인증 요청 값
    sendSuccessMsg: '', // 인증 요청 성공 메세지
    authCode: null, // 인증 코드 입력
    certifySession: null,

    valid: false, // 유효성 검사 유무
    authCodeChk: null, // 인증 코드 틀림 유무 fail//success
    isVisibleAuthCode: false, // 인증 코드 폼 노출 유무
    isSendAuthCode: false, // 인증 코드 전송 유무
    timeOver: true // 시간 만료 유무
  }),
  computed: {
    certifyTypes () {
      return CERTIFY_TYPES()
    },
    certifyType () {
      return this.certifyTypes[this.activeCertify]
    },
    rule () {
      return [
        v => {
          if (this.timeOver) return '인증번호 입력 시간이 만료되었습니다.'
          if (this.authCodeChk === 'fail') return '인증번호 형식을 올바르게 입력해주세요.'
          if (v === null) return '인증번호를 입력해주세요.'
          if (!(/^\d+$/.test(v))) return '인증번호 형식을 올바르게 입력해주세요.'
          return true
        }
      ]
    },
    errorMessage () {
      if (this.timeOver) return '인증번호 입력 시간이 만료되었습니다.'
      return null
    }
  },
  watch: {},
  created () {
    this.getTrialAuthInfo()
  },
  methods: {
    onChangeCertify () {
      this.onReset()
    },
    onReset () {
      this.$refs.timer?.timerStop(this.$refs.timer.Timer)
      this.certifyValue = this.payload[this.certifyType.code]
      this.isVisibleAuthCode = false
      this.onTimeOver()
    },
    onTimeOver () {
      this.valid = false
      this.timeOver = true
      this.authCode = null
      this.isSendAuthCode = false
      this.isLoading = false
    },
    async getTrialAuthInfo() {
      await store.dispatch('getTrialAuthInfo')
          .then(res => {
            if (res.success) {
              this.payload = {
                SMS: Util.Common.replacePhoneNumber(res.data.mobileNo),
                EMAIL: res.data.email
              }
            } else {
              this.$alert(res.msg)
              window.location.href = '/user/login'
            }
          })
      this.onReset()
    },
    onSubmit () {
      // 최초 인증 요청시 인증번호 요청폼 나옴
      if (this.timeOver) {
        // 인증번호 발송 가능
        if (!this.isSendAuthCode) {
          this.requestAuthEmail('인증번호가 발송되었습니다.')
        }
      } else {
        if (this.valid) {
          this.confirmCertEmailNumber()
        }
      }
    },

    async requestAuthEmail (sendSuccessMsg) {
      this.authCode = null
      this.isLoading = true
      this.$refs.timer?.timerStop(this.$refs.timer.Timer)
      let url = ''
      if (this.certifyType.code === 'EMAIL') {
        url = 'postSendEmailCertificationNumber'
      } else {
        url = 'postSendCertificationNumber'
      }
      await store.dispatch(url)
          .then(res => {
            this.sendSuccessMsg = sendSuccessMsg || '인증번호가 재발송되었습니다.'
            if (res.success) {
              this.certifySession = res.data
              this.authCode = null
              this.timeOver = false
              this.isVisibleAuthCode = true
              this.isSendAuthCode = false
              this.$nextTick(() => {
                this.$refs.timer.timerStart()
                this.$refs.submitForm.validate()
                this.$refs.authCode.focus()
                this.$refs.authCode.$el.scrollIntoView({ block: 'start' })
              })
            } else {
              this.$alert(res.msg)
            }
          }).finally(() => {
            this.isLoading = false
            // 메시지 자동 사라지기
            setTimeout(() => {
              this.sendSuccessMsg = null
            }, 2000)
          })
    },

    async confirmCertEmailNumber () {
      const params = {
        savedSessionName: this.certifySession,
        number: this.authCode
      }
      let url = ''
      if (this.certifyType.code === 'EMAIL') {
        url = 'postConfirmEmailCertificationNumber'
      } else {
        url = 'postConfirmCertificationNumber'
      }

      store.dispatch(url, this.$_payload(null, params))
          .then(res => {
            if (res.success) {
              this.$refs.timer.timerStop(this.$refs.timer.Timer)
              this.authCodeChk = 'success'
              let setData = {
                gender: res.data.gender
                , mobileNo: res.data.mobileNo
                , userName: res.data.userName
                , birthyyMmday: res.data.birthDate
                , email: res.data.email
              }
              store.commit('setJoinUser', setData)
              this.$alert('인증이 완료 되었습니다.').then(() => {
                this.$nextTick(() => {
                  this.$router.push('/fo/join/identityAuthenticationComplete')
                })
              })
            } else {
              this.authCode = null
              this.authCodeChk = 'fail'
              this.$refs.submitForm.validate()
            }
          })
    },
    success () {}
  }
}
</script>

<style scoped lang="scss">
::v-deep.v-tabs{
  .v-tabs-bar{
    height: 40px;
    margin-top: 30px;
    .v-slide-group__wrapper{
      background: #F7F7F7;
      border-radius: 20px;
      .v-tab{
        width: 50%;
        max-width: 50%;
        z-index: 2;
        font-weight: 600;
        font-size: 15px;
        color: #7260FF;
        &.v-tab--active{
          color: #fff;
        }
      }
      .v-tabs-slider-wrapper{
        height: 40px !important;
        .v-tabs-slider{
          border-radius: 20px;
        }
      }
    }
  }
}
.account-identity {
  &-content {
    margin: 25px 0;
  }
  &-header {
    line-height: 140%;
  }
  &-label {
    margin-bottom: 15px;
  }
  &-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    font-size: 16px;
    b {
      margin-left: 10px;
    }
  }
  &-body {
    .label {
      margin-bottom: 7px;
    }
    .form-item-block {
      & + .form-item-block {
        margin-top: 7px;
        .label {
          margin-top: 20px;
        }
      }
      .v-input--selection-controls {
        padding-top: 0;
      }
    }
  }
}
</style>

